import React, { Component } from "react";
import PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Grid from "@material-ui/core/Grid";
import SearchOffIcon from "@material-ui/icons/SearchOutlined";
import withCustomStyles from "./NotFoundPart.style";
import ProductsListPart from "./ProductsListPart";
import { GButton, GEmpty } from "./ui";

// Not-found block + "Most popular" products. With showText it stands in for
// a whole page (failed category/brand); without it, it's a section (search).
@inject(["topSellingStore"])
@observer
class NotFoundPart extends Component {
  componentDidMount() {
    this.props.topSellingStore.fetch();
  }

  componentWillUnmount() {
    this.props.topSellingStore.cancel();
  }

  render() {
    const { classes, topSellingStore, showText } = this.props;

    const popular = topSellingStore.all.length > 0 && (
      <section className={classes.popular} aria-labelledby="not-found-popular">
        <h2 id="not-found-popular" className={classes.title}>
          Most popular
        </h2>
        <Grid container className={classes.grid}>
          <ProductsListPart
            listName={"Not Found - Most popular"}
            products={topSellingStore.all}
            state={topSellingStore.fetchState}
          />
        </Grid>
      </section>
    );

    return (
      <>
        <Helmet>
          <meta name="prerender-status-code" content="404" />
        </Helmet>
        {showText ? (
          <main className={classes.page}>
            <GEmpty
              icon={<SearchOffIcon />}
              title="We couldn't find this page"
              action={
                <GButton component={Link} to="/">
                  Go to home
                </GButton>
              }
            >
              It may have moved. Have a look at our most popular products.
            </GEmpty>
            {popular}
          </main>
        ) : (
          popular
        )}
      </>
    );
  }
}

NotFoundPart.propTypes = {
  showText: PropTypes.bool
};

NotFoundPart.defaultProps = {
  showText: true
};

export default withRouter(withCustomStyles(NotFoundPart));
